import React from 'react'
import { useTranslation } from 'react-i18next'
import ShowMoughataa from '../components/moughataa/ShowMoughataa'

const Moughataas:React.FC = () => {
  const { t } = useTranslation()

  return (
    <div className='mt-20'>
      <h1 className='text-center text-3xl'>{t("les Moughataa")}</h1>
      <ShowMoughataa />
    </div>
  )
}

export default Moughataas
